const overlay = (() => {
  let frequency = [10, 75];
  let indexSelected = 0;
  const getFlagsOverlay = () => {
    const flags = [];
    frequency.forEach((item) => {
      const flag = { timePercent: item, reached: false };
      flags.push(flag);
    });
    return flags;
  };

  let flagsOverlays = getFlagsOverlay();

  const isLastOverlay = () => indexSelected >= frequency.length;

  const getOverlaySelected = () => flagsOverlays[indexSelected];

  const checkIfThrowOverlay = (timePercent) => {
    if (
      timePercent > getOverlaySelected().timePercent &&
      timePercent < getOverlaySelected().timePercent + 15 &&
      !getOverlaySelected().reached
    ) {
      getOverlaySelected().reached = true;
      indexSelected += 1;
      return true;
    }
    return false;
  };

  const reset = () => {
    flagsOverlays = getFlagsOverlay();
    indexSelected = 0;
  };

  return {
    flagsOverlays,
    isLastOverlay,
    checkIfThrowOverlay,
    reset,
    setfrequency: (freq) => {
      frequency = freq;
      flagsOverlays = getFlagsOverlay();
    },
  };
})();

export default overlay;
